import { getEnv } from './runtime.config';

/** Backend (niup-me-backend) base URL — all API calls go through it. */
export const API_BASE_URL = getEnv().API_BASE_URL ?? 'http://localhost:3001';
